package com.milta.feature.spreadsheetimport.domain.entity

import com.milta.feature.route.domain.entity.GeocodeFailureReason
import com.milta.feature.route.domain.entity.GeocodeStatus

/**
 * One delivery row read off an uploaded Excel/CSV file (`POST /api/v1/spreadsheet-imports`,
 * contrat validé MIL-27). Mirrors the backend `ImportedDeliveryRow` entity. Nothing is persisted
 * at this stage — every field is raw, unvalidated extraction output; the driver reviews/corrects
 * the rows client-side, then confirms via `POST /routes/{routeId}/deliveries`.
 *
 * [hasMissingFields] is a single opaque boolean from the backend, without detail on *which* field
 * is missing — same ambiguity already flagged on `POST /ocr-scans` (MIL-24/DOM-02). The
 * presentation layer deliberately does NOT rely on it to decide whether a row blocks the batch
 * confirmation — it checks [recipientName]/[address] nullity directly instead, since those are the
 * only two fields the confirmation endpoint actually requires.
 */
data class ImportedDeliveryRow(
    val recipientName: String?,
    val address: String?,
    val phoneNumber: String?,
    val deadlineTime: String?,
    val hasMissingFields: Boolean,
    val packageCount: Int,
    /** HERE validation outcome of [address], resolved server-side before this row reached the client. */
    val geocodeStatus: GeocodeStatus = GeocodeStatus.Pending,
    val latitude: Double? = null,
    val longitude: Double? = null,
    /** Retour 26/10 (R1/R11) — why HERE refused [address] (Failed only), null otherwise. */
    val geocodeFailureReason: GeocodeFailureReason? = null,
    /** Retour 29/10 — the address HERE matched ("Trouvée : …"), null when not reported (older data). */
    val resolvedAddress: String? = null,
)
